import { POSITIONTARIFFAEND} from './PositionTariffaEndTypes'

const initialState = {
    positionTariffaEnd: ""
}

const PositionTariffaEndReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case POSITIONTARIFFAEND:
            
            return {
                positionTariffaEnd: action.load
            }
    
        default:
          return state
    }

}


export default PositionTariffaEndReducer;